import React from "react";
import { ILanguageRenderItem, LanguageRenderItem } from "./LanguageRenderItem";
import { ILanguageItem } from "./LanguageRender";

export interface ILanguageRenderList {
    languageOptions: ILanguageItem[];
}

export const LanguageRenderList: React.FC<ILanguageRenderList> = ({
    languageOptions
}) => (
    <>
        { languageOptions.map(el => (
            <LanguageRenderItem 
                el={el}
            />
        )) }
    </>
)